var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import SectionMenu from "./SectionMenu.vue";
import Component from 'vue-class-component';
import * as echarts from 'echarts';
import HomeService from '../../api/HomeService';
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.inforData = {
            order_reconciliation_n: "",
            order_reconciliation_y: "",
            order_pay_y: "",
            order_pay_n: ""
        };
        _this.option = {
            legend: {
                align: "left",
                itemHeight: 6,
                itemWidth: 6,
                data: [{
                        name: "入库",
                        icon: "circle",
                        textStyle: {}
                    }, {
                        name: "退货",
                        icon: "circle"
                    }],
                right: 20
            },
            tooltip: {
                backgroundColor: "#FF9013",
                padding: 8,
                textStyle: {
                    fontSize: 12,
                },
                formatter: function (params, trigger) {
                    var index = params.dataIndex;
                    var series = _this.option.series, purbackSeries = series[0], purinSeries = series[1];
                    var msg = "<div style=\"text-align:left;\">\u5165\u5E93\u7B14\u6570: " + purinSeries.data[index].num + "\u7B14<br/>\n                            \u5165\u5E93\u91D1\u989D\uFF1A\uFFE5" + purinSeries.data[index].value + "<br/>\n                            \u9000\u5E93\u7B14\u6570: " + purbackSeries.data[index].num + "\u7B14<br/>\n                            \u9000\u5E93\u91D1\u989D\uFF1A\uFFE5" + purbackSeries.data[index].value + "<br/></div>";
                    return msg;
                }
            },
            xAxis: {
                data: [],
                silent: false,
                axisLine: {
                    show: false
                },
                axisTick: {
                    show: false
                },
                splitLine: { show: false },
                splitArea: { show: false }
            },
            yAxis: {
                inverse: false,
                axisLine: {
                    show: false
                },
                axisTick: {
                    show: false
                },
                axisLabel: {
                    color: "#748AA1"
                },
                splitArea: { show: false }
            },
            grid: {
                left: 100
            },
            series: [
                {
                    name: '退货',
                    type: 'bar',
                    stack: 'one',
                    itemStyle: {
                        barBorderRadius: [0, 0, 0, 0],
                        color: "#0A8DFF"
                    },
                    data: [{ num: "", value: "" }]
                },
                {
                    name: '入库',
                    type: 'bar',
                    stack: 'one',
                    barWidth: "15%",
                    itemStyle: {
                        barBorderRadius: [50, 50, 0, 0],
                        color: "#17CEBD"
                    },
                    data: [{ num: "", value: "" }]
                }
            ]
        };
        return _this;
    }
    default_1.prototype.created = function () {
        this.service = HomeService.getInstance();
    };
    default_1.prototype.refresh = function () {
        this.getData();
    };
    default_1.prototype.mounted = function () {
        this.getData();
    };
    ;
    default_1.prototype.initChart = function (data) {
        this.chart = echarts.init(this.$refs.incomeChart);
        var today = new Date();
        var xAxisData = [{ value: "今日", textStyle: {
                    color: "#748AA1"
                } }];
        Array.from({ length: 6 }, function (item, index) {
            var date = new Date(today.getTime() - 24 * 60 * 60 * 1000 * (index + 1)).getDate() + "日";
            xAxisData.unshift({
                value: date,
                textStyle: {
                    color: "#748AA1"
                }
            });
        });
        this.option.xAxis.data = xAxisData;
        this.option.series[0].data = data.purbackData;
        this.option.series[1].data = data.purinData;
        this.chart.setOption(this.option, true);
    };
    default_1.prototype.getData = function () {
        var _this = this;
        this.service.getIncomeData().then(function (res) {
            _this.inforData = res.data.data.total_show;
            var chartData = res.data.data.lately_payment;
            if (chartData) {
                _this.initChart(chartData);
            }
            ;
        }, function (err) {
            _this.$message.error(err.message);
        });
    };
    ;
    default_1 = __decorate([
        Component({
            components: {
                SectionMenu: SectionMenu
            }
        })
    ], default_1);
    return default_1;
}(Vue));
export default default_1;
